<template>
  <!-- 基本信息 -->
  <div class="inputList">
    <labelInput
      :outInput="newform.declarant_name"
      :spanRequired="true"
      normalPlace="请输入申报人姓名"
      @inputChange="labelInput($event, 'declarant_name')"
      spanTitle="申报人姓名"
      :spanWidth="spanWidth"
      componentWidth="520px"
    >
    </labelInput>
    <labelInput
      :outInput="newform.declarant_post"
      :spanRequired="true"
      normalPlace="请输入申报人职务"
      @inputChange="labelInput($event, 'declarant_post')"
      spanTitle="申报人职务"
      :spanWidth="spanWidth"
      componentWidth="520px"
    >
    </labelInput>

    <labelInput
      :outInput="newform.declarant_phone"
      :spanRequired="true"
      normalPlace="请输入申报人电话(手机)"
      @inputChange="labelInput($event, 'declarant_phone')"
      spanTitle="申报人电话(手机)"
      :spanWidth="spanWidth"
      componentWidth="520px"
      :isPhone="true"
      specilType="number"
      :maxLimit="11"
    >
    </labelInput>
    <div style="width: 520px;"></div>

    <labelInput
      :outInput="newform.achievement_name"
      :spanRequired="true"
      normalPlace="请输入成果名称"
      @inputChange="labelInput($event, 'achievement_name')"
      spanTitle="成果名称(成果名称需体现工程名称)"
      spanWidth="240px"
      componentWidth="520px"
    >
    </labelInput>
    <div style="width: 520px;"></div>

    <!-- 成果分组-下拉 -->
    <normalSelect
      :outInput="newform.achievement_group"
      :spanRequired="true"
      pelaceHolder="请选择成果分组"
      @selectCode="labelInput($event, 'achievement_group')"
      :spanWidth="spanWidth"
      :dataList="BIMList"
      componentWidth="520px"
      spanTitle="成果分组"
    >
    </normalSelect>
    <div style="width: 520px;"></div>
    <!-- 成果分组-下拉 -->
    <labelInput
      :outInput="newform.contacts_name"
      :spanRequired="true"
      normalPlace="请输入联系人姓名"
      @inputChange="labelInput($event, 'contacts_name')"
      spanTitle="联系人姓名"
      :spanWidth="spanWidth"
      componentWidth="520px"
    >
    </labelInput>
    <labelInput
      :outInput="newform.contacts_phone"
      :spanRequired="true"
      normalPlace="请输入电话"
      @inputChange="labelInput($event, 'contacts_phone')"
      spanTitle="联系人电话"
      :spanWidth="spanWidth"
      componentWidth="520px"
      :isPhone="true"
      specilType="number"
      :maxLimit="11"
    >
    </labelInput>
    <labelInput
      :outInput="newform.contacts_address"
      :spanRequired="true"
      normalPlace="请输入联系地址"
      @inputChange="labelInput($event, 'contacts_address')"
      spanTitle="联系地址"
      :spanWidth="spanWidth"
      componentWidth="520px"
    >
    </labelInput>
    <div style="width: 520px;"></div>

    <!--  -->
    <p class="view_head midflex">申报单位</p>
    <!-- 下拉 -->
    <normalSelect
      :outInput="type1"
      :spanRequired="true"
      pelaceHolder="请选择企业类型"
      @selectCode="typeThreeInput($event, '0', '0')"
      :spanWidth="spanWidth"
      :dataList="installList"
      componentWidth="520px"
      spanTitle="单位1"
    >
    </normalSelect>
    <labelInput
      :outInput="name1"
      :spanRequired="true"
      normalPlace="请输入单位名称"
      @inputChange="typeThreeInput($event, '0', '1')"
      spanTitle="单位名称"
      :spanWidth="spanWidth"
      componentWidth="520px"
    >
    </labelInput>
    <!-- 下拉 -->
    <normalSelect
      :outInput="type2"
      :spanRequired="true"
      pelaceHolder="请选择企业类型"
      @selectCode="typeThreeInput($event, '1', '0')"
      :spanWidth="spanWidth"
      :dataList="installList"
      componentWidth="520px"
      spanTitle="单位2"
    >
    </normalSelect>
    <!--  -->
    <labelInput
      :outInput="name2"
      :spanRequired="true"
      normalPlace="请输入单位名称"
      @inputChange="typeThreeInput($event, '1', '1')"
      spanTitle="单位名称"
      :spanWidth="spanWidth"
      componentWidth="520px"
    >
    </labelInput>
    <!-- 下拉 -->
    <normalSelect
      :outInput="type3"
      :spanRequired="true"
      pelaceHolder="请选择企业类型"
      @selectCode="typeThreeInput($event, '2', '0')"
      :spanWidth="spanWidth"
      :dataList="installList"
      componentWidth="520px"
      spanTitle="单位3"
    >
    </normalSelect>
    <!--  -->
    <labelInput
      :outInput="name3"
      :spanRequired="true"
      normalPlace="请输入单位名称"
      @inputChange="typeThreeInput($event, '2', '1')"
      spanTitle="单位名称"
      :spanWidth="spanWidth"
      componentWidth="520px"
    >
    </labelInput>

    <labelInput
      :outInput="newform.leading_member"
      :spanRequired="true"
      normalPlace="请输入团队主要成员"
      specilType="textarea"
      @inputChange="labelInput($event, 'leading_member')"
      :maxLimit="999"
      spanTitle="团队主要成员(限6人以内)"
      :spanWidth="spanWidth"
      componentWidth="520px"
    >
    </labelInput>
  </div>
</template>

<script>
import labelInput from "../../../../components/table/labelInput.vue";
import normalSelect from "../../../../components/table/normalSelect.vue";
export default {
  data() {
    return {
      type1: "",
      name1: "",
      type2: "",
      name2: "",
      type3: "",
      name3: "",

      newform: {},
      spanWidth: "180px",
      BIMList: [
        [
          {
            name: "BIM技术单项应用",
            code: "BIM技术单项应用",
          },
          {
            name: "BIM技术综合应用",
            code: "BIM技术综合应用",
          },
        ],
      ],
      installList: [
        [
          {
            name: "建设",
            code: "建设",
          },
          {
            name: "设计",
            code: "设计",
          },
          {
            name: "施工",
            code: "施工",
          },
        ],
      ],
      // BIM基本信息
      form: {
        declarant_name: "",
        declarant_post: "",
        declarant_phone: "",
        achievement_name: "",
        achievement_group: "",
        contacts_name: "",
        contacts_phone: "",
        contacts_address: "",
        // declarant_units: '',
        leading_member: "",
      },
      listArray: [{}, {}, {}],
    };
  },
  components: {
    labelInput,
    normalSelect,
  },
  props: {
    basicMsg: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    basicMsg(newvalue) {
      this.newform = {
        ...newvalue,
      };
      const newList = JSON.parse(newvalue.declarant_units);
      this.type1 = newList[0].type;
      this.name1 = newList[0].name;
      this.type2 = newList[1].type;
      this.name2 = newList[1].name;
      this.type3 = newList[2].type;
      this.name3 = newList[2].name;
    },
  },
  created() {
    this.$emit("basicInfo", this.form);
  },
  methods: {
    // 普通基本信息提交
    labelInput(e, name) {
      this.form[name] = e;
      this.$emit("basicInfo", this.form);
    },
    // 上传申报的三个单位
    typeThreeInput(e, index, id) {
      if (id === "0") {
        this.listArray[index]["type"] = e;
      } else {
        this.listArray[index]["name"] = e;
      }
      this.$emit("moreSelect", this.listArray);
    },
  },
};
</script>

<style scoped>
.inputList {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}

.view_head {
  font-size: 18px;
  font-weight: 600;
  margin-top: 20px;
}

.midflex {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
}
</style>
